/* tslint:disable */
import {
  StockQuantPackage,
  LotQualityAnalysis,
  ProductionOrderOutLine
} from '../index';

declare var Object: any;
export interface FilterValuesQualityAnalysisInterface {
  "id"?: number;
  "name"?: string;
  "quality_analysis_id"?: number;
  "type"?: string;
  "out_line_id"?: number;
  "package_id"?: number;
  "initial_value"?: number;
  "final_value"?: number;
  "filter_size"?: number;
  package?: StockQuantPackage;
  qualityAnalysis?: LotQualityAnalysis;
  outLine?: ProductionOrderOutLine;
}

export class FilterValuesQualityAnalysis implements FilterValuesQualityAnalysisInterface {
  "id": number;
  "name": string;
  "quality_analysis_id": number;
  "type": string;
  "out_line_id": number;
  "package_id": number;
  "initial_value": number;
  "final_value": number;
  "filter_size": number;
  package: StockQuantPackage;
  qualityAnalysis: LotQualityAnalysis;
  outLine: ProductionOrderOutLine;
  constructor(data?: FilterValuesQualityAnalysisInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `FilterValuesQualityAnalysis`.
   */
  public static getModelName() {
    return "FilterValuesQualityAnalysis";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of FilterValuesQualityAnalysis for dynamic purposes.
  **/
  public static factory(data: FilterValuesQualityAnalysisInterface): FilterValuesQualityAnalysis{
    return new FilterValuesQualityAnalysis(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'FilterValuesQualityAnalysis',
      plural: 'FilterValuesQualityAnalysiss',
      path: 'FilterValuesQualityAnalysiss',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "quality_analysis_id": {
          name: 'quality_analysis_id',
          type: 'number'
        },
        "type": {
          name: 'type',
          type: 'string'
        },
        "out_line_id": {
          name: 'out_line_id',
          type: 'number'
        },
        "package_id": {
          name: 'package_id',
          type: 'number'
        },
        "initial_value": {
          name: 'initial_value',
          type: 'number'
        },
        "final_value": {
          name: 'final_value',
          type: 'number'
        },
        "filter_size": {
          name: 'filter_size',
          type: 'number'
        },
      },
      relations: {
        package: {
          name: 'package',
          type: 'StockQuantPackage',
          model: 'StockQuantPackage',
          relationType: 'belongsTo',
                  keyFrom: 'package_id',
          keyTo: 'id'
        },
        qualityAnalysis: {
          name: 'qualityAnalysis',
          type: 'LotQualityAnalysis',
          model: 'LotQualityAnalysis',
          relationType: 'belongsTo',
                  keyFrom: 'quality_analysis_id',
          keyTo: 'id'
        },
        outLine: {
          name: 'outLine',
          type: 'ProductionOrderOutLine',
          model: 'ProductionOrderOutLine',
          relationType: 'belongsTo',
                  keyFrom: 'out_line_id',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/FilterValuesQualityAnalysis.ts